module.exports = __webpack_public_path__ + "img/2.403d1f56.png";